// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Order_item_requests_RemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for POST /so/order_item_requests/remover/{id}
 *
 * Action endpoint — hard-deletes a single request row. Emits an empty
 * success envelope (no dados payload).
 *
 * @see So_order_item_requests_model::delete()
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Order_item_requests_RemoverResponseDados = null;

export type Order_item_requests_RemoverResponse = ApiResponse<Order_item_requests_RemoverResponseDados>;

registerResponseContract('Order_item_requests_RemoverResponse', {})
